import { KEYS } from '@internal/constants';

export const getUser = () => JSON.parse(localStorage.getItem(KEYS.USER));

export const setUser = (user) => localStorage.setItem(KEYS.USER, JSON.stringify(user));

export const removeUser = () => localStorage.removeItem(KEYS.USER);